import { render, staticRenderFns } from "./CalculosTab.vue?vue&type=template&id=8fda856e&scoped=true&"
import script from "./CalculosTab.vue?vue&type=script&lang=js&"
export * from "./CalculosTab.vue?vue&type=script&lang=js&"
import style0 from "./CalculosTab.vue?vue&type=style&index=0&id=8fda856e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fda856e",
  null
  
)

export default component.exports